/*
 * This file is part of glowingblue/welcome-page.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat, Lhamo.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import { slug } from '../common';

app.initializers.add(slug, () => {
	extend(SignUpModal.prototype, 'onSignUpSuccessCallbacks', function (callbacks) {
		const pageId = app.forum.attribute(`${slug}.page_id`);
		if (Number.parseInt(pageId) >= 0) {
			callbacks.setContent('get-on-success-route', () => app.route('page', { id: pageId }));
		}
	});
});
